export default {
    //计算价格
    order_computePrice: "client/order/skipAuth/calculatePrice",
    //查询订单列表
    order_queryOrderList: "client/order/queryOrderList",
    //获取订单优惠信息
    order_getDiscountInfo: "client/coupon/coupon/optimal",
    //创建订单
    order_createOrder: "client/order/createOrder",
    //获取订单倒计时 时间
    order_getOrderCancelTime: "client/order/getOrderCancelTime",
    //更新发票订单
    order_updateInvoice: "client/order/invoice/updateOrderInvoice",
    //查询 配送方式配置列表
    order_queryDistributionConfigList:
        "client/distribution/selectUserDistribution",
    //订单 更新订单
    order_updatePayType: "client/order/editOrderPayType",
    //订单查询是否加急状态
    order_queryUrgentStatus: "client/order/queryOrderPriorityInfo",
};
